import axios from 'axios'
import { createRouter, createWebHistory } from 'vue-router'

import MENU from '@/constantes/controle_acesso/MENU'
import { reset } from '@/posthog'
import Autenticacao from '@/servicos/Autenticacao'
import Store from '@/stores'
import Agenda from '@/templates/agenda/Agenda'
import Agendamento from '@/templates/agendamento/Agendamento'
import Backup from '@/templates/backup/Backups'
import Cid from '@/templates/cid/Cid'
import CidCadastro from '@/templates/cid/CidCadastro'
import ConvenioCadastro from '@/templates/convenio/ConvenioCadastro'
import Convenios from '@/templates/convenio/Convenios'
import DocumentoCadastro from '@/templates/documento/DocumentoCadastro'
import Documentos from '@/templates/documento/Documentos'
import Dominio from '@/templates/dominio/Dominio'
import DominioCadastro from '@/templates/dominio/DominioCadastro'
import Especialidade from '@/templates/especialidade/Especialidade'
import EspecialidadeCadastro from '@/templates/especialidade/EspecialidadeCadastro'
import EsqueciSenha from '@/templates/EsqueciSenha'
import Faturamento from '@/templates/faturamento/Faturamento'
import FaturamentoArquivoPromed from '@/templates/faturamento/FaturamentoArquivoPromed'
import FaturamentoCadastro from '@/templates/faturamento/FaturamentoCadastro'
import FaturamentoGuia from '@/templates/faturamento/FaturamentoGuia'
import GuiaSPSADTCadastro from '@/templates/guia/guia_sp_sadt/cadastro/GuiaCadastro'
import GuiaSPSADTConsultaAgendamentos from '@/templates/guia/guia_sp_sadt/consulta/agendamentos/GuiaAgendamentos'
import GuiaSPSADTConsulta from '@/templates/guia/guia_sp_sadt/consulta/GuiaConsulta'
import Home from '@/templates/Home'
import Login from '@/templates/Login'
import MedicoCadastro from '@/templates/medico/MedicoCadastro'
import MedicoConsulta from '@/templates/medico/Medicos'
import NovaSenha from '@/templates/NovaSenha'
import PacienteAgendamentos from '@/templates/paciente/agendamentos/PacienteAgendamentos'
import PacienteCadastro from '@/templates/paciente/PacienteCadastro'
import PacienteEvolucao from '@/templates/paciente/PacienteEvolucao'
import PacienteEvolucao2 from '@/templates/paciente/PacienteEvolucao2'
import Pacientes from '@/templates/paciente/Pacientes'
import ProfissionalAgendamentos from '@/templates/profissional/agendamentos/ProfissionalAgendamentos'
import ProfissionalBloqueio from '@/templates/profissional/bloqueio/ProfissionalBloqueio'
import ProfissionalBloqueioCadastro from '@/templates/profissional/bloqueio/ProfissionalBloqueioCadastro'
import GuiasPagamento from '@/templates/profissional/pagamento/GuiasPagamento'
import Profissionais from '@/templates/profissional/Profissionais'
import ProfissionalCadastro from '@/templates/profissional/ProfissionalCadastro'
import Formulario from '@/templates/prontuario/formulario/Formulario'
import FormularioCadastro from '@/templates/prontuario/formulario/FormularioCadastro'
import Questao from '@/templates/prontuario/questao/Questao'
import QuestaoCadastro from '@/templates/prontuario/questao/QuestaoCadastro'
import RelatorioAgendamentosDesativados from '@/templates/relatorios/agendamentosDesativados/Relatorio'
import AtendimentoPlano from '@/templates/relatorios/atendimentoPlano/Relatorio'
import AtendimentoProfissionalRelatorio from '@/templates/relatorios/atendimentoProfissional/Relatorio'
import GuiasNaoFaturadasRelatorio from '@/templates/relatorios/guiasNaoFaturadas/Relatorio'
import RelatorioHorariosAbertosVsMarcados from '@/templates/relatorios/horariosAbertosVsMarcados/Relatorio'
import IndicacaoMedico from '@/templates/relatorios/indicacaoPorGuia/Relatorio'
import RelatorioLevantamentoMarketing from '@/templates/relatorios/levantamentoMarketing/Relatorio'
import MediaEvaPorEspecialidadeRelatorio from '@/templates/relatorios/mediaEvaPorEspecialidade/Relatorio'
import PagamentoGuiaRelatorio from '@/templates/relatorios/pagamentoGuias/Relatorio'
import PagamentoIndicacaoGuiaRelatorio from '@/templates/relatorios/pagamentoIndicacaoGuias/Relatorio'
import PagamentoProfissionalRelatorio from '@/templates/relatorios/pagamentoProfissional/Relatorio'
import TabelasProcedimentoConsulta from '@/templates/tabelasProcedimento/TabelasProcedimento'
import TabelasProcedimentoCadastro from '@/templates/tabelasProcedimento/TabelasProcedimentoCadastro'
import UsuarioBloqueio from '@/templates/usuario/bloqueio/Bloqueio'
import UsuarioBloqueioCadastro from '@/templates/usuario/bloqueio/BloqueioCadastro'
import TrocarSenha from '@/templates/usuario/TrocarSenha'
import UsuarioCadastro from '@/templates/usuario/UsuarioCadastro'
import Usuarios from '@/templates/usuario/Usuarios'
import { haVersaoNova } from '@/utils/versao-nova'

const autenticacao = new Autenticacao()
const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: { requerAutenticacao: false },
    },
    {
      path: '/esqueci-senha',
      name: 'EsqueciSenha',
      component: EsqueciSenha,
      meta: { requerAutenticacao: false },
    },
    {
      path: '/nova-senha/:hash',
      name: 'NovaSenha',
      component: NovaSenha,
      meta: { requerAutenticacao: false },
    },
    {
      path: '/usuario/cadastro/:id?',
      name: 'UsuarioCadastro',
      component: UsuarioCadastro,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/usuario/nova-senha/:id?',
      name: 'TrocarSenha',
      component: TrocarSenha,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/usuario',
      name: 'Usuarios',
      component: Usuarios,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/usuario/bloqueio',
      name: 'UsuarioBloqueio',
      component: UsuarioBloqueio,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/usuario/bloqueio/cadastro/:id?',
      name: 'UsuarioBloqueioCadastro',
      component: UsuarioBloqueioCadastro,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/paciente',
      name: 'Pacientes',
      component: Pacientes,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/paciente/cadastro/:id?',
      name: 'PacienteCadastro',
      component: PacienteCadastro,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/paciente/:id/evolucao',
      name: 'PacienteEvolucao',
      component: PacienteEvolucao,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/paciente/:id/evolucao2',
      name: 'PacienteEvolucao2',
      component: PacienteEvolucao2,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/paciente/:id/agendamentos',
      name: 'PacienteAgendamentos',
      component: PacienteAgendamentos,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/profissional',
      name: 'Profissional',
      component: Profissionais,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/profissional/cadastro/:id?',
      name: 'ProfissionalCadastro',
      component: ProfissionalCadastro,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/profissional/:id/agendamentos',
      name: 'ProfissionalAgendamentos',
      component: ProfissionalAgendamentos,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/profissional/bloqueio',
      name: 'ProfissionalBloqueio',
      component: ProfissionalBloqueio,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/profissional/bloqueio/cadastro/:id?',
      name: 'ProfissionalBloqueioCadastro',
      component: ProfissionalBloqueioCadastro,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/convenio',
      name: 'Convenio',
      component: Convenios,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/convenio/cadastro/:id?',
      name: 'ConvenioCadastro',
      component: ConvenioCadastro,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/agendamento',
      name: 'Agendamento',
      component: Agendamento,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/agenda',
      name: 'Agenda',
      component: Agenda,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/guia/cadastro/:id?',
      name: 'GuiaSPSADTCadastro',
      component: GuiaSPSADTCadastro,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/guia',
      name: 'GuiaSPSADTConsulta',
      component: GuiaSPSADTConsulta,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/guia/:guiaId/agendamentos',
      name: 'GuiaSPSADTConsultaAgendamentos',
      component: GuiaSPSADTConsultaAgendamentos,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/guia/cadastro/:agendamentoId?/agendamento',
      name: 'GuiaSPSADTCadastroAgendamento',
      component: GuiaSPSADTCadastro,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/medico/cadastro/:id?',
      name: 'MedicoCadastro',
      component: MedicoCadastro,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/medico',
      name: 'Medicos',
      component: MedicoConsulta,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/relatorio/pagamento_profissional',
      name: 'PagamentoProfissionalRelatorio',
      component: PagamentoProfissionalRelatorio,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/relatorio/pagamento_guia',
      name: 'PagamentoGuiaRelatorio',
      component: PagamentoGuiaRelatorio,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/relatorio/pagamento_indicacao_guia',
      name: 'PagamentoIndicacaoGuiaRelatorio',
      component: PagamentoIndicacaoGuiaRelatorio,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/relatorio/atendimento_profissional',
      name: 'AtendimentoProfissionalRelatorio',
      component: AtendimentoProfissionalRelatorio,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/relatorio/atendimento_plano',
      name: 'AtendimentoPlano',
      component: AtendimentoPlano,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/relatorio/indicacao_medico',
      name: 'IndicacaoMedico',
      component: IndicacaoMedico,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/tabelasProcedimento',
      name: 'TabelasProcedimentoConsulta',
      component: TabelasProcedimentoConsulta,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/tabelasProcedimento/cadastro/:id?',
      name: 'TabelasProcedimentoCadastro',
      component: TabelasProcedimentoCadastro,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/cid',
      name: 'Cid',
      component: Cid,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/cid/cadastro/:id?',
      name: 'CidCadastro',
      component: CidCadastro,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/especialidade',
      name: 'Especialidade',
      component: Especialidade,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/especialidade/cadastro/:id?',
      name: 'EspecialidadeCadastro',
      component: EspecialidadeCadastro,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/faturamento/',
      name: 'Faturamento',
      component: Faturamento,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/faturamento/cadastro/:id?',
      name: 'FaturamentoCadastro',
      component: FaturamentoCadastro,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/faturamento/guia',
      name: 'FaturamentoGuia',
      component: FaturamentoGuia,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/faturamento/promed/arquivo',
      name: 'FaturamentoArquivoPromed',
      component: FaturamentoArquivoPromed,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/evolucao/questao',
      name: 'Questao',
      component: Questao,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/evolucao/questao/cadastro/:id?',
      name: 'QuestaoCadastro',
      component: QuestaoCadastro,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/evolucao/formulario',
      name: 'Formulario',
      component: Formulario,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/evolucao/formulario/cadastro/:id?',
      name: 'FormularioCadastro',
      component: FormularioCadastro,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/relatorio/levantamento_marketing',
      name: 'LevantamentoMarketing',
      component: RelatorioLevantamentoMarketing,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/relatorio/agendamentos_desativados',
      name: 'AgendamentosDesativados',
      component: RelatorioAgendamentosDesativados,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/documento/cadastro',
      name: 'DocumentoCadastro',
      component: DocumentoCadastro,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/documento',
      name: 'Documentos',
      component: Documentos,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/relatorio/horarios_abertos_vs_marcados',
      name: 'RelatorioHorariosAbertosVsMarcados',
      component: RelatorioHorariosAbertosVsMarcados,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/backup/download',
      name: 'BackupDownload',
      component: Backup,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/dominio',
      name: 'Dominio',
      component: Dominio,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/dominio/cadastro/:id?',
      name: 'DominioCadastro',
      component: DominioCadastro,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/relatorio/media_eva_especialidade',
      name: 'MediaEvaPorEspecialidadeRelatorio',
      component: MediaEvaPorEspecialidadeRelatorio,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/relatorio/guias_nao_faturadas',
      name: 'GuiasNaoFaturadasRelatorio',
      component: GuiasNaoFaturadasRelatorio,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/profissional/pagamento/guias',
      name: 'GuiasPagamento',
      component: GuiasPagamento,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/home',
      alias: '/',
      name: 'Home',
      component: Home,
      meta: { requerAutenticacao: true },
    },
    {
      path: '/:pathMatch(.*)*',
      name: '404',
      component: Home,
      meta: { requerAutenticacao: false },
    },
  ],
})

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error && error.response ? error.response.status : null
    const requestUrl =
      error && error.config && error.config.url ? error.config.url : ''
    const isAuthEndpoint =
      requestUrl.includes('/login') ||
      requestUrl.includes('/usuario/recuperacao-senha')

    if (status === 401 && !isAuthEndpoint) {
      reset(true)
      localStorage.removeItem('tactus-token')
      Store.setAutenticado(false)

      if (router.currentRoute.path !== '/login') {
        router.push('/login')
      }
    }

    return Promise.reject(error)
  }
)

router.beforeEach((to) => {
  // Recarrega no destino para carregar o bundle novo sem perder um formulário em edição.
  if (haVersaoNova()) {
    window.location.assign(router.resolve(to).href)
    return false
  }

  if (!to.meta.requerAutenticacao) {
    return true
  }

  autenticacao.verificaAutenticacao()
  if (!Store.usuario.autenticado) {
    return '/login'
  }

  Store.setUsuario(autenticacao.getUsuario())
  autenticacao.sincronizarIdentidadePosthog(Store.versaoBackend)

  const perfil = autenticacao.getUsuario().perfil
  const path = to.fullPath.substring(1, to.fullPath.length)
  const menu = MENU.valores.find((m) => m.path === path)
  let podeExibir = true

  if (menu && menu.perfil) {
    if (menu.perfil.exibir) {
      if (!menu.perfil.exibir.includes(perfil)) {
        podeExibir = false
      }
    } else if (menu.perfil.ocultar) {
      if (menu.perfil.ocultar.includes(perfil)) {
        podeExibir = false
      }
    }
  }

  if (podeExibir) {
    return true
  }
  return '/login'
})

export default router
